import React from "react";
import { BaseDropdownMenuItemIcon } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
export default function DropdownMenuItemIconContainer(_ref) {
  var icon = _ref.icon;
  var Component = icon && icon.type;
  return /*#__PURE__*/_jsx(BaseDropdownMenuItemIcon, {
    children: /*#__PURE__*/_jsx(Component, {
      color: "currentColor"
    })
  });
}